var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7247 12.7247C12.9688 12.4806 13.3645 12.4806 13.6086 12.7247L16.9419 16.0581C17.186 16.3021 17.186 16.6979 16.9419 16.9419C16.6979 17.186 16.3021 17.186 16.0581 16.9419L12.7247 13.6086C12.4806 13.3645 12.4806 12.9688 12.7247 12.7247Z",
    fill: "#737387"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.16667 2.125C4.82995 2.125 2.125 4.82995 2.125 8.16667C2.125 11.5034 4.82995 14.2083 8.16667 14.2083C9.83809 14.2083 11.35 13.5304 12.4445 12.4331C13.5351 11.3395 14.2083 9.83232 14.2083 8.16667C14.2083 4.82995 11.5034 2.125 8.16667 2.125ZM0.875 8.16667C0.875 4.13959 4.13959 0.875 8.16667 0.875C12.1937 0.875 15.4583 4.13959 15.4583 8.16667C15.4583 10.1765 14.6443 11.9975 13.3295 13.3158C12.0101 14.6387 10.1835 15.4583 8.16667 15.4583C4.13959 15.4583 0.875 12.1937 0.875 8.16667Z",
    fill: "#737387"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/search.f75807dde14faf6dc67704147fb757b4.svg";